import { instance } from "hooks/useRequest/helper";
import { PROVINCES_URL, CITIES_URL } from "api/routes";
import { IServerGetResponse } from "rules/interface/api/response";
import { IProvince } from "rules/interface/province/province.interface";
import { ICity } from "rules/interface/city/city.interface";
import ICityParams from "rules/interface/api/city/city-params.interface";



export const getProvinces = async (): Promise<IServerGetResponse<IProvince[]>> => {
    return await instance.get(PROVINCES_URL)
        .then(res => res.data)
};

export const getCities = async ({ city, params }: { params?: ICityParams, city?: string }): Promise<IServerGetResponse<ICity[] | ICity>> => {
    return await instance.get(CITIES_URL + `${city ? ("/" + city) : ""}`, { params })
        .then(res => res.data)
};